import { render, staticRenderFns } from "./registeredByCategory.vue?vue&type=template&id=6e69658e"
import script from "./registeredByCategory.vue?vue&type=script&lang=js"
export * from "./registeredByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports